import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import adapter from "./adapter";
import service from "./service";

const initialState = {
  _payload: null,
  status: "idle",
  error: "",
  data: [],
  data_options: [],
};

export const fetchCities = createAsyncThunk(
  "cities/fetchCities",
  async (options) => {
    const data = await service.getData(options);
    return data;
  }
);

export const citiesSlice = createSlice({
  name: "cities",
  initialState,
  reducers: {
    setStatus(state, action){
      state.status = action.payload
    },
  },
  extraReducers: {
    [fetchCities.pending]: (state) => {
      state.status = "loading";
    },
    [fetchCities.fulfilled]: (state, action) => {
      state.status = "succeeded";
      state._payload = action.payload;
      // const payload = adapter.responseBodyToRender(action.payload);
      state.data = action.payload;
      state.data_options = matchOptions(action.payload)
    },
    [fetchCities.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error.message;
    },
  },
});

function matchOptions(payload) {
  let result = [];

  if(payload && payload.length > 0){
    for (let index = 0; index < payload.length; index++) {
      const element = payload[index];
      result.push({
        label: element.kotakab,
        value: element.kotakab
      })
    }
  }

  return result
}

export const { setStatus } = citiesSlice.actions

export default citiesSlice.reducer;
